import {Gallery} from 'bliss-gallery'
export default class DestroyGallery extends Gallery {
  constructor(element, options) {
    super(element, options)
  }
  destroy() {
    this.slider.style = null
    this.slides.forEach(slide => {
      slide.style = null
    })
    this.element.dataset.playing = false
    this.autoPlay = false

    this.slides.forEach(slide => {
      slide.removeAttribute('data-slide-position')
    })
    this.element.removeAttribute('data-playing')
    this.element.removeAttribute('data-hide-controls')

    let clone = this.element.cloneNode()
    while (this.element.firstChild) {
      clone.appendChild(this.element.lastChild)
    }
    // this.element.parentNode.replaceChild(clone, this.element)
    this.element.parentNode.replaceChild(clone, this.element)
  }
}
